/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Ai_AgentsInputs */

const en_nav_ai_agents = /** @type {(inputs: Nav_Ai_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Agents`)
};

const es_nav_ai_agents = /** @type {(inputs: Nav_Ai_AgentsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agentes de IA`)
};

/**
* | output |
* | --- |
* | "AI Agents" |
*
* @param {Nav_Ai_AgentsInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const nav_ai_agents = /** @type {((inputs?: Nav_Ai_AgentsInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Ai_AgentsInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_ai_agents(inputs)
	return es_nav_ai_agents(inputs)
});